'use strict';

document.addEventListener('DOMContentLoaded', function() {
    (function() {
        
        const customModal = document.createElement('div');
        customModal.id = 'customModal';
        customModal.style.display = 'none';
        customModal.style.position = 'fixed';
        customModal.style.zIndex = '8';
        customModal.style.left = '0';
        customModal.style.top = '0';
        customModal.style.width = '100%';
        customModal.style.height = '100%';
        customModal.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        customModal.style.justifyContent = 'center';
        customModal.style.alignItems = 'center';
        customModal.style.transition = '0.3s';

        const modalContent = document.createElement('div');
        modalContent.className = 'modal-content';
        modalContent.style.backgroundColor = '#fff';
        modalContent.style.padding = '20px';
        modalContent.style.borderRadius = '5px';
        modalContent.style.position = 'relative';
        modalContent.style.maxWidth = '500px'; 
        modalContent.style.margin = 'auto'; 

        const closeButton = document.createElement('span');
        closeButton.textContent = '×';
        closeButton.style.position = 'absolute';
        closeButton.style.right = '10px';
        closeButton.style.top = '10px';
        closeButton.style.cursor = 'pointer';
        closeButton.style.fontSize = '20px';
        modalContent.appendChild(closeButton);

        customModal.appendChild(modalContent);
        document.body.appendChild(customModal);

        
        function showModal(content) {
            modalContent.insertAdjacentHTML('beforeend', content);
            customModal.style.display = 'flex'; 
        }

        
        function hideModal() {
            modalContent.innerHTML = '';
            modalContent.appendChild(closeButton);
            customModal.style.display = 'none';
        }

        
        closeButton.onclick = hideModal;

        
        document.onkeydown = function(event) {
            if (event.key === 'Escape') {
                hideModal();
            }
        };

       
        customModal.addEventListener('click', function(e) {
            if (e.target === customModal) {
                hideModal();
            }
        });

        document.body.addEventListener('click', function(e) {
            if (e.target.classList.contains('js-wbquickview-link')) {
                e.preventDefault();
                const currentTarget = e.target;
                const productUrl = currentTarget.dataset.url;
                const variantId = currentTarget.getAttribute('variant-id');
                let url = productUrl;

                if (productUrl.indexOf("?") > 0) {
                    url = productUrl.substring(0, productUrl.indexOf("?"));
                }

                fetch(url + '?view=wbquickview' + (variantId !== undefined ? '&variant=' + variantId : ''))
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.text();
                    })
                    .then(data => {
                        if (!data) { return; }
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(data, 'text/html');
                        const html = doc.querySelector('[data-html="content"]');

                        if (html) {
                            showModal(html.innerHTML);
                        } else {
                            console.error('Content not found in fetched data');
                        }
                        const addToCartButtonListener = function(event) {
                            if (event.target.classList.contains('product-form__submit')) {
                                setTimeout(function() {
                                    hideModal();
                                }, 1200);
                            }
                        };

                        document.addEventListener('click', addToCartButtonListener, { once: true });

                    })
                    .catch(error => {
                        console.error('There was a problem with the fetch operation:', error);
                    });
            }
        });
        window.addEventListener('beforeunload', hideModal);

    })();
});
